import { type ReplacementConfig, type ImageReplacement } from '../types';

const isImage = (element: HTMLElement): element is HTMLImageElement =>
  element.tagName === 'IMG';

export const imageProcessor: ReplacementConfig<ImageReplacement> = {
  selector: 'img',
  processor: (element) => {
    if (isImage(element)) {
      return {
        type: 'image',
        img: element,
        src: element.getAttribute('src') || '',
        alt: element.getAttribute('alt') || '',
        width: element.getAttribute('width') || undefined,
        height: element.getAttribute('height') || undefined,
        style: element.getAttribute('style') || undefined,
      };
    }
    return {};
  },
};
